import { render, staticRenderFns } from "./FormMetadataTableComponent.vue?vue&type=template&id=ae7f30c4&scoped=true&lang=pug"
import script from "./FormMetadataTableComponent.vue?vue&type=script&lang=js"
export * from "./FormMetadataTableComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae7f30c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ae7f30c4')) {
      api.createRecord('ae7f30c4', component.options)
    } else {
      api.reload('ae7f30c4', component.options)
    }
    module.hot.accept("./FormMetadataTableComponent.vue?vue&type=template&id=ae7f30c4&scoped=true&lang=pug", function () {
      api.rerender('ae7f30c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/data-platform/components/FormMetadataTableComponent.vue"
export default component.exports